<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p> </p>
<div class="_idGenObjectStyleOverride-1" id="_idContainer007">
<p class="Epigram ParaOverride-1"><span class="epigraph CharOverride-9">But if you think that by hanging us you can stamp out the labor </span><span class="epigraph CharOverride-9">movement—the movement from which the downtrodden millions, the millions</span><span class="epigraph CharOverride-9"> </span><span class="epigraph CharOverride-9">who toil and live in want and misery, the wage slaves, expect salvation—if </span><span class="epigraph CharOverride-9">this is your opinion, then hang us! Here you will tread upon a spark, but here, and </span><span class="epigraph CharOverride-9">there and behind you, and in front of you, and everywhere the flames will blaze up.</span><span class="epigraph CharOverride-9"> It is a subterranean fire. You cannot put it out. The ground is on fire upon which you stand.</span></p>
<p class="Text-body-after-subhead ParaOverride-3"><span class="Text-body CharOverride-10">—August Spies, </span><span class="attribution _idGenCharOverride-1">Haymarket</span><span class="Text-body CharOverride-10"> martyr, speech at trial, October 7, 1886</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi1.vue?740d0340